module.exports = __webpack_public_path__ + "static/media/9.decdac10.png";